<template>
	<div v-show="$store.state.showAiAnswer" class="ai-push-answer-box">
		<div v-for="obj in $store.state.aiAuxiliaryAnswer" class="answer-box">
			<template v-if="obj.isAiRecommend">
				<p>{{ obj.msgContent }}</p>
				<div class="btn-box">
					<a class="send-ai" href="javascript:;" @click="sendNewAiRecommend(obj)">发送</a>
				</div>
			</template>
			<template v-else>
				<p>{{ obj.msgContent }}</p>
				<div class="btn-box">
					<a class="send-ai" href="javascript:;" @click="aiAnswerCorrect(obj, true)">发送</a>
					<a class="correct" href="javascript:;" @click="aiAnswerCorrect(obj)">正确</a>
					<a class="error" href="javascript:;" @click="aiAnswerError(obj)">错误</a>
					<a class="optimization" href="javascript:;" @click="optimizationAiAnswer(obj)">优化</a>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'aiAnswer',
	data () {
		return {}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		conversationList () {
			return this.$store.state.conversationList;
		},
		currentSessionId () {
			return this.$store.state.currentSessionId;
		}
	},
	methods: {
		// 发送新的AI推荐答案
		sendNewAiRecommend (obj) {
			var self = this,
				data = {
					uid: obj.uid,
					que: obj.que,
					ans: obj.msgContent,
					shopId: obj.shopId
				};

			self.$emit('sendMsg', obj.msgContent);
			self.$store.commit('changeShowAiAnswer', false);

			$.ajax({
				url: API_ROOT.newDetectionUrl + '/click/recordClick.do',
				data: data,
				type: 'get',
				contentType: "application/json;charset=UTF-8"
			});
		},

		// AI推送的是正确的答案
		aiAnswerCorrect (obj, needSend) {
			var self = this,
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				data = {
					serviceType: self.currentShop.serviceType,
					msgMapping: {
						msgIdSend: obj.id,
						sessionId: self.currentSessionId,
						shopId: self.currentShop.id,
						evaluate: 1,
						aiMsg: obj.msgContent,
						clientMsg: ''
					}
				};

			self.$store.commit('changeShowAiAnswer', false);
			let length = conversationObj.data ? conversationObj.data.length : 0
			for (var i = 0; i < length; i++) {
				var msgObj = conversationObj.data[i];
				if (msgObj.uuid == obj.uuid) {
					data.msgMapping.clientMsg = msgObj.msgContent;
					break;
				}
			}
			if (needSend) {
				self.$emit('sendMsg', obj.msgContent, {isAiRelpy: 2}, function(param) {
					try {
						data.msgMapping.msgIdReceive = param.data.msgId;
					} catch(e) {
						data.msgMapping.msgIdReceive = 0;
					}
					submit();
				});
			} else {
				submit();
			}

			function submit () {
				self.$axios.post(API_ROOT.url + '/AISettingsApi.markAIMsgMapping', data).then();
			}
		},

		// AI推送的是错误答案
		aiAnswerError (obj) {
			var self = this,
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				data = {
					serviceType: self.currentShop.serviceType,
					msgMapping: {
						msgIdSend: obj.id,
						sessionId: self.currentSessionId,
						shopId: self.currentShop.id,
						evaluate: 2,
						aiMsg: obj.msgContent,
						clientMsg: ''
					}
				};

			self.$store.commit('changeShowAiAnswer', false);
			let length = conversationObj.data ? conversationObj.data.length : 0
			for (var i = 0; i < length; i++) {
				var msgObj = conversationObj.data[i];
				if (msgObj.uuid == obj.uuid) {
					data.msgMapping.clientMsg = msgObj.msgContent;
					break;
				}
			}
			self.$axios.post(API_ROOT.url + '/AISettingsApi.markAIMsgMapping', data).then();
		},

		// 优化AI答案
		optimizationAiAnswer (obj) {
			var self = this,
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				data = {
					msgIdSend: obj.id,
					sessionId: self.currentSessionId,
					shopId: self.currentShop.id,
					evaluate: 3,
					aiMsg: obj.msgContent,
					clientMsg: ''
				};

			let length = conversationObj.data ? conversationObj.data.length : 0
			for (var i = 0; i < length; i++) {
				var msgObj = conversationObj.data[i];
				if (msgObj.uuid == obj.uuid) {
					data.clientMsg = msgObj.msgContent;
					break;
				}
			}

			self.$store.commit('changeShowAiAnswer', false);
			self.$store.commit('changeOptimizationAi', data);
			self.$store.commit('changeShowOptimizationAi', true);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/msgList/aiAnswer.vue